// index.js or main file
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import Login from './pages/login/login';
import UserRules from './pages/rules/rules';
import ThankYou from './pages/thankyou/thankyou';
import Game from './pages/game/game';
import Leaderboard from './pages/leaderboard/Leaderboard';
import USER from './pages/dddUI/user';

// Benign Chrome warning when modals/route changes trigger ResizeObserver in the same frame.
const RESIZE_OBSERVER_LOOP = /ResizeObserver loop/;
window.addEventListener(
  'error',
  (event) => {
    if (RESIZE_OBSERVER_LOOP.test(event.message ?? '')) {
      event.stopImmediatePropagation();
    }
  },
  true
);

function usePageBackground() {
  const location = useLocation();
  useEffect(() => {
    const body = document.body;
    if (
      location.pathname === "/" ||
      location.pathname.startsWith("/login") ||
      location.pathname.startsWith("/game") ||
      location.pathname.startsWith("/thankyou") ||
      location.pathname.startsWith("/leaderboard")
    ) {
      body.classList.remove("common-bg");
    } else {
      body.classList.add("common-bg");
    }
  }, [location]);
}

function App() {
  usePageBackground();

  return (
    <Provider store={store}>
      <USER>
        <Routes>
          <Route index element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/rules" element={<UserRules />} />
          <Route path="/game" element={<Game />} />
          <Route path="/welcome" element={<Navigate to="/game" replace />} />
          <Route path="/stage1" element={<Navigate to="/game" replace />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/thankyou" element={<ThankYou />} />
        </Routes>
      </USER>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
